"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Image = require("../Image");

var _Image2 = _interopRequireDefault(_Image);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MenuItemBox = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "MenuItem__MenuItemBox",
  componentId: "v5kokc-0"
})(["width:260px;height:342px;border:1px solid #ececec;margin:20px;border-radius:10px;box-shadow:0 0 4px 0 rgba(0,0,0,0.08);transition:all 0.2s ease;&:hover{cursor:pointer;transform:scale(1.01);box-shadow:0 0 8px 0 rgba(0,0,0,0.15);}"]);

const EllipsisText = (0, _styledComponents2.default)(_Text2.default).withConfig({
  displayName: "MenuItem__EllipsisText",
  componentId: "v5kokc-1"
})(["width:210px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

const EllipsisBox = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "MenuItem__EllipsisBox",
  componentId: "v5kokc-2"
})(["text-overflow:ellipsis;overflow:hidden;display:-webkit-box !important;-webkit-line-clamp:5;-webkit-box-orient:vertical;white-space:normal;"]);

const StyledMenuItem = ({
  brand,
  brandLogo,
  imageUrl,
  title,
  description,
  price
}) => {
  return _react2.default.createElement(
    MenuItemBox,
    null,
    _react2.default.createElement(
      _Flex2.default,
      { alignItems: "center" },
      _react2.default.createElement(_Image2.default, { borderRadius: "50%", width: 50, height: 50, src: brandLogo }),
      _react2.default.createElement(
        _Text2.default,
        { fontSize: 0, ml: 2 },
        brand
      )
    ),
    _react2.default.createElement(_Image2.default, {
      src: imageUrl,
      width: "260px !important",
      height: "160px !important"
    }),
    _react2.default.createElement(
      _Box2.default,
      { p: 2 },
      _react2.default.createElement(
        _Flex2.default,
        { alignItems: "center", justifyContent: "space-between", mb: 2 },
        _react2.default.createElement(
          EllipsisText,
          { fontWeight: 500, fontSize: 1 },
          title
        ),
        _react2.default.createElement(
          _Text2.default,
          { fontWeight: 500 },
          price
        )
      ),
      _react2.default.createElement(
        EllipsisBox,
        { color: "palette.ink.600" },
        _react2.default.createElement(
          _Text2.default,
          { fontSize: 1 },
          description
        )
      )
    )
  );
};

const MenuItem = props => {
  return _react2.default.createElement(StyledMenuItem, props);
};

MenuItem.defaultProps = {
  brandLogo: "https://popmenucloud.com/cdn-cgi/image/width=600,height=600,fit=scale-down,format=auto,quality=60/vdegtjyh/f0879e07-f03b-476b-84ea-4d84faf827c0.png",
  brand: "EAST SIDE BANH MI",
  title: "Pork Banh Mi",
  description: `Roasted black pepper-caramel pork shoulder with fried shallot mayo, pickled veggies, cilantro, cucumber, jalapeños, and maggi seasoning on a 8" baguette`,
  imageUrl: "https://popmenucloud.com/cdn-cgi/image/width=1200,height=1200,fit=scale-down,format=auto,quality=60/vdegtjyh/e7424958-f38a-4b9a-9876-b038a85e77e5.jpg",
  price: "$11"
};

MenuItem.propTypes = {
  brandLogo: _propTypes2.default.string,
  brand: _propTypes2.default.string,
  title: _propTypes2.default.string,
  price: _propTypes2.default.string,
  description: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string
};

exports.default = MenuItem;